import { Component, Input, OnChanges, inject } from '@angular/core';
import { ACCOUNT_ID_PARAM, APPLICATION_ROUTES } from 'src/app/constants/application-routes';

import { IneligibleReasons } from '../../../../common/enums/ineligible-scenarios.enum';
import { NavOverflowExtendedData } from '../../../interfaces/nav-overflow-extended-data.interface';
import { OwnAccountsService } from '../../../services/own-accounts/own-accounts.service';
import { ContentUtil } from '../../../utils/content/content.util';
import { OwnAccountTileInputDataProps } from '../../../utils/sort/sort.service';
import { MapAccountTypePipe } from 'src/app/pipes/map-account-type/map-account-type.pipe';
import { UserCountComponent } from '../../user-count/user-count.component';
import { TileComponent } from '../tile.component';
import { NgIf } from '@angular/common';
import { isInternalEnvironment } from 'src/common/utils/common.util';
import { LegalFormsComponent } from 'src/common/components/legal-forms/legal-forms.component';

@Component({
    selector: 'zci-own-account-tile',
    templateUrl: './own-account-tile.component.html',
    imports: [
        NgIf,
        TileComponent,
        UserCountComponent,
        MapAccountTypePipe,
        LegalFormsComponent,
    ],
})
export class OwnAccountTileComponent implements OwnAccountTileInputDataProps, OnChanges {
    private readonly ownAccountsService = inject(OwnAccountsService);

    content = ContentUtil.content;

    navOverflowMenuConfig: NavOverflowExtendedData;

    isInternal = isInternalEnvironment();

    @Input() accId: string;

    @Input() accName: string;

    @Input() accType: string;

    @Input() agentsCount: number;

    @Input() accountIsIneligibleFor: Array<IneligibleReasons>;

    @Input() grantorIsIneligibleFor: Array<IneligibleReasons>;

    @Input() hasIneligibleError: boolean;

    @Input() sagId: string;

    @Input() poid: string;

    ngOnChanges() {
        let ineligibleReasons = [...this.grantorIsIneligibleFor, ...this.accountIsIneligibleFor];

        ineligibleReasons = ineligibleReasons.sort();

        if (ineligibleReasons.includes(IneligibleReasons.MANAGED_ACCOUNT)) {
            ineligibleReasons.pop();
        }

        const ineligibleReason = ineligibleReasons[ineligibleReasons.length - 1];

        if (this.accId) {
            this.navOverflowMenuConfig = this.ownAccountsService.getNavOverflowMenu(
                this.agentsCount,
                this.accId,
                ineligibleReason,
                this.hasIneligibleError,
            );
        }
    }

    get usersOnAccountPath(): string {
        return APPLICATION_ROUTES.USERS_ON_ACCOUNT.CHILD_PATH.replace(
            `:${ACCOUNT_ID_PARAM}`,
            this.accId,
        );
    }
}
